import { useState } from "react";
import { faqs } from "@/mocks/comics";
import { SectionHeading } from "./HotComics";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="mx-auto px-4 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-8">
        <div className="lg:col-span-1">
          <SectionHeading
            anchor="faq"
            kicker="常见问题 · FAQ"
            title="关于韩漫免费阅读，你想知道的都在这"
            desc="整理了读者最常问的问题与解答，帮助你快速上手本站的免费阅读体验。"
          />
        </div>

        <div className="lg:col-span-2 space-y-3">
          {faqs.map((f, i) => (
            <div
              key={i}
              className="rounded-lg bg-background-900/70 border border-background-800/60 overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                aria-expanded={open === i}
              >
                <span className="text-sm md:text-base font-semibold text-foreground-100">{f.q}</span>
                <i
                  className={`${
                    open === i ? "ri-subtract-line text-primary-400" : "ri-add-line text-foreground-400"
                  } text-xl shrink-0`}
                />
              </button>
              {open === i && (
                <p className="px-5 pb-5 text-sm text-foreground-400 leading-relaxed">{f.a}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}